"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpHeaders = /** @class */ (function () {
    function HttpHeaders() {
    }
    HttpHeaders.LocationHeader = "location";
    HttpHeaders.SetRegistrationTokenHeader = "set-registrationtoken";
    HttpHeaders.RegistrationTokenHeader = "RegistrationToken";
    HttpHeaders.RegistrationTokenHeaderValue = "registrationToken=";
    HttpHeaders.ContentTypeHeader = "content-type";
    HttpHeaders.AuthenticationHeader = "authentication";
    HttpHeaders.BehaviorOverrideHeader = "behavioroverride";
    HttpHeaders.SkypeTokenHeaderValue = "skypetoken=";
    HttpHeaders.SetEndpointProperty = "supportsMessageProperties";
    return HttpHeaders;
}());
exports.default = HttpHeaders;
//# sourceMappingURL=HttpHeaders.js.map